import { DOCUMENTS } from '../../constants/requerimentDocuments';
import { Channels } from '@/core/constants/channelConstants';

export default {
  //when channel is PR and is an update
  applies(context, taxRegimes) {
    return (
      context.channel === Channels.WHOLESALER &&
      context.isIncrease &&
      context.taxRegime === taxRegimes.COORPORATE.value
    );
  },
  fields() {
    const fields = {
      [DOCUMENTS.PROMISSORY_NOTE.value]: DOCUMENTS.PROMISSORY_NOTE,
      [DOCUMENTS.SUBSCRIBER_ID.value]: DOCUMENTS.SUBSCRIBER_ID,
      [DOCUMENTS.GUARANTOR_ID.value]: DOCUMENTS.GUARANTOR_ID,
      [DOCUMENTS.SUBSCRIBER_ADDRESS.value]: DOCUMENTS.SUBSCRIBER_ADDRESS,
      [DOCUMENTS.GUARANTOR_ADDRESS.value]: DOCUMENTS.GUARANTOR_ADDRESS,
      [DOCUMENTS.TAX_STATUS_CERTIFICATE.value]:
        DOCUMENTS.TAX_STATUS_CERTIFICATE,
      [DOCUMENTS.ARTICLES_OF_INCORPORATION.value]:
        DOCUMENTS.ARTICLES_OF_INCORPORATION,
      [DOCUMENTS.FINANCIAL_STATEMENT.value]: DOCUMENTS.FINANCIAL_STATEMENT,
      [DOCUMENTS.CREDIT_BUREAU_AUTH.value]: DOCUMENTS.CREDIT_BUREAU_AUTH,
      [DOCUMENTS.CREDIT_APPLICATION.value]: DOCUMENTS.CREDIT_APPLICATION,
      [DOCUMENTS.ON_SITE_INSPECTION_REPORT.value]:
        DOCUMENTS.ON_SITE_INSPECTION_REPORT,
    };
    return fields;
  },
};
